module.exports = __webpack_public_path__ + "static/img/undefined.1260588.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/undefined.svg
// module id = bqgO
// module chunks = 1